// One comparator for every dropdown, so options read in the same order everywhere. The
// locale is pinned: collation is locale-specific and would otherwise vary per browser.
// @since NEXT_VERSION
const collator = new Intl.Collator("en", { sensitivity: "base" });

// Compared trimmed and case/accent-insensitively, so an option sorts where the reader sees
// it. Digits compare as characters ("Task 10" before "Task 2"); missing text sorts first.
// @since NEXT_VERSION
export const compareText = (a, b) =>
  collator.compare(String(a ?? "").trim(), String(b ?? "").trim());

// Sorts a copy: the option lists come from React state and Redux, which must not be mutated.
// @since NEXT_VERSION
export const sortByText = (list, toText) =>
  (Array.isArray(list) ? [...list] : []).sort((a, b) => compareText(toText(a), toText(b)));

// The common case: already-normalised `[{ label }]` options.
// @since NEXT_VERSION
export const sortByLabel = (options) => sortByText(options, (o) => o?.label);

// Master records that carry a display `name` (member and manager rows).
// @since NEXT_VERSION
export const sortByName = (records) => sortByText(records, (r) => r?.name);
